import * as types from './Types'

const initialState = {
    Products: [],
    ProductInfo: {},
    SingleRecode: {},
    ProposerInsurer: {},
    AllLife: [],
    loading: true
}

export const offlinePolicyReducers = (state = initialState, action) => {
    const { type, payload } = action

    switch (type) {

        case types.GET_ALL_ACTIVE_PRODUCT: return {
            ...state,
            Products: payload,
            loading: false
        }
        case types.PRODUCT_INFO_STORE: return {
            ...state,
            ProductInfo: payload,
            loading: false
        }
        case types.STORE_SINGLE_RECODE: return {
            ...state,
            SingleRecode: payload,
            loading: false
        }
        case types.STORED_PROPOSER_INSURER_DETAILS: return {
            ...state,
            ProposerInsurer: payload,
            loading: false
        }

        case types.RESET_STATE: return {
            ...state,
            SingleRecode: initialState.SingleRecode,
            ProposerInsurer: initialState.ProposerInsurer
        }
        case types.GET_ALL_LIFE: return {
            ...state,
            AllLife: payload,
            loading: false
        }

        default:
            return state
    }
}

export default offlinePolicyReducers
